import { useState } from "react";
import { AlertColor } from "@mui/material";
import { AxiosError, AxiosResponse } from "axios";

export type Alert = {
  type: AlertColor;
  message: string;
  errorCode?: number;
} | null;

interface ErrorResponse {
  message: string;
}

function useHttpResponseAlert(
  error: AxiosError | null,
  success?: AxiosResponse,
  altMessage?: string,
) {
  const [alert, setAlert] = useState<Alert>(null);
  const [prevSuccess, setPrevSuccess] = useState(success);
  const [prevError, setPrevError] = useState(error);

  // Recompute alert when success or error reference changes (React's
  // "adjust state during render" pattern, replacing a setState-in-effect).
  if (success !== prevSuccess || error !== prevError) {
    setPrevSuccess(success);
    setPrevError(error);

    if (success && success.status >= 200 && success.status <= 299) {
      setAlert({
        type: "success",
        message: success.data.message || altMessage || "Success!",
      });
    }

    if (error) {
      setAlert({
        type: "error",
        message:
          (error.response?.data as ErrorResponse)?.message ||
          error.message ||
          "An unexpected error occurred",
        errorCode: error.response?.status,
      });
    }
  }

  return {
    alert,
    setAlert,
  };
}

export default useHttpResponseAlert;
